import * as React from 'react'
import type { SVGProps } from 'react'
function SvgFreieFlachenBaulucken221982627171(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 246.3 205.2"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M127.9,83.1c1.7,0,3-1.4,3-3s-1.4-3-3-3H72.2c-1.7,0-3.1,1.4-3.1,3s1.4,3,3.1,3H127.9z" />
        <path d="M172,98c2.2,1.8,4.9,2.8,7.8,2.8c0.4,0,0.9,0,1.3-0.1c3.3-0.3,6.3-1.9,8.3-4.5l10-12.2c0.5-0.6,0.8-1.4,0.7-2.2 c-0.1-0.8-0.5-1.5-1.1-2.1l-30.6-25V7.4c0-1.7-1.4-3.1-3-3.1h-30.2c-1.7,0-3,1.4-3,3.1v17.7L102,0.7c-1.1-0.9-2.7-0.9-3.9,0l-97,79 c-0.6,0.5-1,1.2-1.1,2.1c-0.1,0.8,0.2,1.6,0.7,2.2l10,12.2c2.4,2.9,5.9,4.6,9.6,4.6c2.8,0,5.6-1,7.8-2.8l72-58.7L172,98z  M162.2,49.8l-24.1-19.6V10.5h24.1V49.8z M102,33c-0.5-0.4-1.2-0.7-1.9-0.7s-1.4,0.2-1.9,0.7L24.2,93.3c-2.7,2.2-6.6,1.8-8.8-0.9 l-8-9.9L100,7l92.7,75.5l-8,9.9c-1.1,1.3-2.6,2.1-4.2,2.3c-1.7,0.2-3.3-0.3-4.6-1.4L102,33z" />
        <path d="M67.9,114.9v56c0,1.7,1.4,3,3,3h68.6c1.7,0,3-1.4,3-3v-56c0-1.7-1.4-3-3-3H71C69.3,111.9,67.9,113.2,67.9,114.9z  M136.6,167.9h-28.2v-35.4c0-1.7-1.4-3-3-3c-1.7,0-3.1,1.4-3.1,3v35.4H74V118h62.6V167.9z" />
        <path d="M243.2,199.1h-27.6v-20.8c16.3-1.2,25.2-11.9,25.2-30.4c0-22.2-12.7-40.2-28.2-40.2s-28.2,18-28.2,40.2 c0,18.6,8.9,29.3,25.2,30.4v20.8h-41.2v-88.6c0-1.7-1.4-3-3-3s-3,1.4-3,3v88.6H37.9v-88.6c0-1.7-1.4-3-3.1-3c-1.7,0-3,1.4-3,3v91.6 c0,1.7,1.4,3,3,3h130.4c0,0,0,0,0,0s0,0,0,0h77.9c1.7,0,3-1.4,3-3S244.9,199.1,243.2,199.1z M212.6,172.2 c-14.7,0-22.1-8.2-22.1-24.4c0-18.8,9.9-34.1,22.1-34.1c12.2,0,22.2,15.3,22.2,34.1C234.7,164,227.3,172.2,212.6,172.2z" />
      </g>
    </svg>
  )
}
export default SvgFreieFlachenBaulucken221982627171
